import cn from 'clsx';
import { cva } from 'class-variance-authority';

import styles from './LoadingResultCard.module.css';

const imageSkeletonVariants = cva(styles.imageSkeleton, {
  variants: {
    variant: {
      default: styles.defaultImageSkeleton,
      preview: styles.previewImageSkeleton,
    },
  },
});

const contentWrapperVariants = cva(styles.contentWrapper, {
  variants: {
    variant: {
      default: styles.defaultContentWrapper,
      preview: styles.previewContentWrapper,
    },
  },
});

export const LoadingResultCard = ({ className, variant = 'default' }: { className?: string; variant?: 'default' | 'preview' }) => {
  return (
    <div className={cn(styles.container, className)} data-test="skeleton">
      <div className={imageSkeletonVariants({ variant })} />
      <div className={contentWrapperVariants({ variant })}>
        <div className={styles.contentSkeleton} />
        <div className={styles.contentSkeleton} />
        {variant === 'default' && <div className={styles.contentSkeleton} />}
        <div className={styles.row}>
          <div className={styles.contentSkeleton} />
          <div className={styles.contentSkeleton} />
        </div>
      </div>
    </div>
  );
};
